@if(initializeRender && DataTableSchema){
<!-- Table Header -->
@if((DataTableSchema['isSearchRequired'] && DataTableSchema['searchInfo']) || DataTableSchema['isExportRequired'] ||
DataTableSchema['tableTitle']){
<header
    [ngClass]="{'filter-actions-container':true,'filter-actions-top':!DataTableSchema['isSearchRequired'] && (props && props.istitleCenter) }">

    <div class="material-table-search header-elements">
        @if(DataTableSchema['isSearchRequired'] && DataTableSchema['searchInfo']){
        <mat-form-field [hidden]="!(DataTableSchema['isSearchRequired'] && DataTableSchema['searchInfo'])"
            class="cbl-search-filter" appearance="fill" [style]="DataTableSchema['searchInfo']['style']" >
            <input type="text" matInput matTooltip="{{isFilterDisabled ? 'No data available for filter' :''}}"
                [(ngModel)]="DataTableSchema.inputFilter" [disabled]="isFilterDisabled"
                [placeholder]="DataTableSchema['searchInfo']['placeholder']" (input)="onSearchInput($event)"
                (paste)="onSearchPaste($event)" (click)="filterFieldOnClick($event)" onkeypress="" />
            <span matSuffix>
                <button (click)="applyFilter()" class="filter-button"> <mat-icon matPrefix
                        class="filter-icon">search</mat-icon></button>
            </span>
        </mat-form-field>
        }
    </div>


    @if(DataTableSchema['tableTitle']){
    <div class="header-elements">
        <span class="filter-actions-container dynamic-table-title">
            {{DataTableSchema.isTitleCamelCase ? (DataTableSchema.tableTitle | camelCase) : DataTableSchema.tableTitle}}
        </span>
    </div>
    }
    <div class="header-elements action-elements">
        @if(DataTableSchema['headerActions']){
        @for(action of DataTableSchema.headerActions; track idx; let idx = $index){
        <app-header-action-button [action]="action" (buttonClicked)="action['onClick']?.($event)">
        </app-header-action-button>
        }
        }
        @if(DataTableSchema['isExportRequired']){
        <app-download-button class="table-header-actions" [tableValues]="dataSource['data']"
            (buttonClicked)="exportTableData()"
            exportMessage="{{DataTableSchema.exportConfig?.exportMessage}}"></app-download-button>
        }
    </div>
</header>
}

<!-- Scrollable Table Content -->
<div [ngClass]="{'table-content-gap':DataTableSchema['isTableGap']}" class="table-content mat-elevation-z8">

    <table mat-table [dataSource]="dataSource" class="mat-table" matSort
        [ngClass]="{'page-fullheight': isFullHeight, 'compact-table': !!DataTableSchema.tableRowHeight}" stickyHeader
        #tableRef>

        @if(isMultiHeader){
        <ng-container>
            @for(col of DataTableSchema.columnSchema; track idx; let idx = $index){
            <ng-container>
                <ng-container matColumnDef="{{col.fieldKey}}" [sticky]="col.sticky">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="col.sub_headers?.length || 1"
                        class="group-header">
                        {{ col.label |camelCase}}
                    </th>
                </ng-container>
            </ng-container>
            }
        </ng-container>
        }
        @for(col of flattenedColumns; track idx; let idx = $index){
        <ng-container>
            <ng-container matColumnDef="{{col.fieldKey}}" [sticky]="col.sticky">
                @if(col?.fieldType === 'Actions'){
                <th mat-header-cell *matHeaderCellDef> {{col.isCamelCaseHeader ? col.label : (col.label | camelCase) }}
                </th>
                <td mat-cell *matCellDef="let element" [class.clickable]="col.onClick" class="action-column"
                    [ngClass]="{'column-field-action':col.onClick}">
                    @for(action of col?.actionConfig; track idx; let idx = $index){
                    @if((action['dependentFieldName'] && element[action['dependentFieldName']]) ||
                    !action['dependentFieldName']){
                    <div class="dynamic-table-actions">
                        <div (click)="action.onClick?.(element, col)" onKeyDown="" class="dynamic-table-action-element"
                            [matTooltip]="!action?.isCustomToolTip ? action?.toolTip : null"
                            [appTooltipOverlay]="action?.isCustomToolTip ? { template: tooltipTemplate, context: element } : null">
                            @if(action.hasBadge){
                            <button [matBadge]="element[action['badgeField']]" matBadgeOverlap="false"
                                matButton="elevated" [matBadgeHidden]="!action.hasBadge"
                                style="font-size: 15px;background:transparent;border: none;">
                                <span [ngStyle]="{'color':action['color']}"
                                    [ngClass]="(action.iconClass)? action.iconClass : ''"></span>
                                {{action?.actionLabel ?? ''}}
                            </button>
                            }@else{
                            <span [ngStyle]="{'color':action['color']}"
                                [ngClass]="(action.iconClass)? action.iconClass : ''"></span>
                            {{action?.actionLabel ?? ''}}
                            }
                        </div>
                    </div>
                    } @else if(action['alt']){
                    <div class="dynamic-table-action-element-alt"
                        [matTooltip]="!action?.isCustomToolTip ? action?.alt : null"
                        [appTooltipOverlay]="action?.isCustomToolTip ? { template: tooltipTemplate, context: element } : null">
                        <span [ngStyle]="{'color':action['color'], 'cursor':'default'}"></span>{{action?.alt ?? ''}}
                    </div>
                    }
                    }
                </td>
                }@else if(col?.fieldType === 'file'){
                <th mat-header-cell *matHeaderCellDef>
                    {{ col.isCamelCaseHeader ? col.label : (col.label | camelCase) }}
                </th>
                <td mat-cell *matCellDef="let element">
                    @if(element[col.fieldKey]){
                    @if(isArray(element[col.fieldKey])){
                    @for(file of element[col.fieldKey]; track idx1; let idx1 = $index){
                    <span [ngClass]="{'column-field-action':col.onClick}" style="display: block" onkeypress=""
                        [class.clickable]="col.onClick"
                        (click)="col.onClick?.(element,file)">{{file['displayName']}}</span>
                    }
                    }
                    }@else{
                    <span style="display: block;">{{'N/A'}}</span>
                    }
                </td>
                }@else{
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="col.isSortable !== false ? col.fieldKey : null" [class.active]="isSorted(col.fieldKey)"
                    class="custom-sort-header" [disabled]="!dataSource.data.length || col.isSortable === false"
                    [matTooltip]="col.tooltip ? col.label : null">
                    {{ col.isCamelCaseHeader ? col.label : (col.label | camelCase) }}
                    @if(dataSource.data.length && col.isSortable !== false){
                    @if(isSorted(col.fieldKey)){
                    <span class="sort-icon-wrapper">
                        <span class="sort-order">{{getSortOrder(col.fieldKey)}}</span>
                        @if(getSortDirection(col.fieldKey) === 'asc'){
                        <i class="fa-solid fa-arrow-up sort-icon"></i>
                        }@else{
                        <i class="fa-solid fa-arrow-down sort-icon"></i>
                        }
                    </span>
                    }@else{
                    <span class="hover-sort-icon">
                        <i class="fa-solid fa-sort sort-icon"></i>
                    </span>
                    }
                    }
                </th>

                <td mat-cell *matCellDef="let element" onkeypress="" [class.clickable]="col.onClick"
                    (click)="col.onClick?.(element)" [ngClass]="{'column-field-action':col.onClick}"
                    [style.display]="shouldHideCell(element, col.fieldKey) ? 'none' : ''"
                    [attr.rowspan]="getCellRowSpan(element, col.fieldKey) || null">
                    @if(col.isProgressBar){
                    <div style="display:flex; align-items:center; gap:8px; width:100%;">
                        <mat-progress-bar [value]="+element[col.fieldKey] || 0" mode="determinate" color="primary"
                            style="flex:1;">
                        </mat-progress-bar>
                        <span style="min-width:40px;"> {{ element[col.fieldKey] || 0 }}%</span>
                    </div>
                    }
                    @else{
                    {{formatCellValue(col, element[col.fieldKey])}}
                    <span *ngIf="col.isPercent">%</span>
                    }
                </td>
                }
                <td mat-footer-cell *matFooterCellDef>
                    {{ idx === 0 ? (DataTableSchema.footerConfig?.labelColumnText) :col?.isCurrency
                    ?((getTotalCount(col.fieldKey) | currency)) : getTotalCount(col.fieldKey) }}
                </td>

            </ng-container>
        </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="isMultiHeader ? mainHeaderRows : DataTableSchema.displayedColumns"></tr>
        @if(isMultiHeader){<tr mat-header-row *matHeaderRowDef="DataTableSchema.displayedColumns"></tr>}
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="DataTableSchema.displayedColumns.length" style="text-align: center;">
                @if(DataTableSchema.isLoading){
                <div class="table-row-skeleton-container">
                    @for(row of [1, 2, 3, 4, 5]; track row){
                    <div class="table-row-skeleton"
                        [style.gridTemplateColumns]="'repeat(' + (DataTableSchema.displayedColumns.length || 1) + ', minmax(100px, 1fr))'">
                        @for(col of DataTableSchema.displayedColumns; track col){
                        <div class="table-row-skeleton-cell"></div>
                        }
                    </div>
                    }
                </div>
                }@else{
                No data available
                }
            </td>
        </tr>
        @if(DataTableSchema.isFooterRequired) {
        <tr mat-footer-row *matFooterRowDef="DataTableSchema.displayedColumns">
            }
        <tr mat-row *matRowDef="let row; columns: DataTableSchema.displayedColumns"
            [class.highlightRow]="row['CblHighlightRow'] === true"></tr>
    </table>
</div>

<!-- Fixed Footer with Paginator -->
<footer class="paginator-footer">
    @if(props && props.updatedOn && (dataSource && dataSource.data.length>0)){
    <p class="detail-updatedOn">
        <b>Last Updated On: </b>{{props.updatedOn| date:'MM/dd/yyyy'}}
    </p>
    }
    @if(DataTableSchema['isPaginationRequired']){
    <mat-paginator class="mat-paginator-container" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageChanged($event)" showFirstLastButtons></mat-paginator>
    }
</footer>
@if(DataTableSchema['isNote'] && props && props.description){
<div class="area-note mb-0">
    <ul class="p-4 pb-0">
        @for(info of props.description; track idx; let idx = $index){
        <li>{{ info }}</li>
        }
    </ul>
</div>
}
<ng-template #tooltipTemplate let-data>
    <mat-card class="dynamic-table-tooltip-container">
        <div *ngFor="let opt of DataTableSchema['toolTip']; let idx = index" class="custom-tooltip-content">
            {{ formatCellTooltip(data, opt) }}
        </div>
    </mat-card>
</ng-template>
}